"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootAccountInfoSagas = void 0;
var RootMemberPageSaga_1 = require("@/pages/common/sagas/RootMemberPageSaga");
var AccountInfoAction_1 = require("@/pages/accountInfo/actions/AccountInfoAction");
var effects_1 = require("redux-saga/effects");
var editPersonalInfo_1 = require("@/pages/accountInfo/sagas/api/editPersonalInfo");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var BigPopupState_1 = require("@/pages/common/states/BigPopupState");
var EditAccountInfoFormFields_1 = require("@/pages/accountInfo/states/EditAccountInfoFormFields");
var WindowApi_1 = require("@/api/browser/WindowApi");
var stateFilter_1 = require("@/pages/common/sagas/stateFilter");
var getAccountForm = function (state) {
    var _a = state.accountInfo.account, salutation = _a.salutation, email = _a.email, firstname = _a.firstname, lastname = _a.lastname, language = _a.language, currency = _a.currency, birthdayDate = _a.birthdayDate, phone = _a.phone;
    var date = new Date(birthdayDate.replace(/-/g, '/'));
    var birthdayDay = "" + date.getDate();
    var birthdayMonth = "" + (date.getMonth() + 1);
    var birthdayYear = "" + date.getFullYear();
    var birthday = birthdayYear + "/" + birthdayMonth + "/" + birthdayDay;
    var phoneNumber = phone.body ? phone.code + "-" + phone.body : '';
    return {
        email: email,
        phoneNumber: phoneNumber,
        birthday: birthday,
        birthdayDay: birthdayDay,
        birthdayMonth: birthdayMonth,
        birthdayYear: birthdayYear,
        salutation: salutation,
        firstName: firstname,
        lastName: lastname,
        middleName: '',
        preferredCurrency: currency,
        preferredLanguage: language,
    };
};
var getAllYears = function (state) { return state.accountInfo.years; };
var getTForm = function (state) { return state.accountInfo.tForm; };
var watchOnEditClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(AccountInfoAction_1.default.ACCOUNT_INFO_ON_EDIT_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(AccountInfoAction_1.default.setIsEditing(true))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchOnCancelClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(AccountInfoAction_1.default.ACCOUNT_INFO_ON_CANCEL_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(AccountInfoAction_1.default.setIsEditing(false))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchOnDeleteAccountClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 2];
                return [4 /*yield*/, effects_1.take(AccountInfoAction_1.default.ACCOUNT_INFO_ON_DELETE_ACCOUNT_CLICK)];
            case 1:
                _a.sent();
                return [3 /*break*/, 0];
            case 2: return [2 /*return*/];
        }
    });
};
var watchOnUpdateClick = function () {
    var editAccountInfoForm, response, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 13];
                return [4 /*yield*/, effects_1.take(AccountInfoAction_1.default.ACCOUNT_INFO_ON_UPDATE_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getAccountForm)];
            case 2:
                editAccountInfoForm = _a.sent();
                _a.label = 3;
            case 3:
                _a.trys.push([3, 10, , 12]);
                return [4 /*yield*/, effects_1.call(editPersonalInfo_1.editPersonalInfo, editAccountInfoForm)];
            case 4:
                response = _a.sent();
                if (!response.isSaved) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setBigPopupLocalized('account_update_success', BigPopupState_1.BigPopupType.SUCCESS, 'success', 'updateSuccess'))];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.put(AccountInfoAction_1.default.setIsEditing(false))];
            case 6:
                _a.sent();
                return [3 /*break*/, 9];
            case 7: return [4 /*yield*/, effects_1.put(AccountInfoAction_1.default.setServerErrors(response.validationList[0].messages))];
            case 8:
                _a.sent();
                _a.label = 9;
            case 9: return [3 /*break*/, 12];
            case 10:
                e_1 = _a.sent();
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setBigPopupLocalized('account_update_failed', BigPopupState_1.BigPopupType.FAILED, 'failed', e_1.toString()))];
            case 11:
                _a.sent();
                return [3 /*break*/, 12];
            case 12: return [3 /*break*/, 0];
            case 13: return [2 /*return*/];
        }
    });
};
var getFormError = function (form) {
    var errors = [];
    if (!form.firstName.trim() || !form.lastName.trim() || !form.salutation) {
        errors.push(EditAccountInfoFormFields_1.EditAccountInfoFormFields.NAME);
    }
    if (!form.phoneNumber.trim().replace(/\D/ig, '')) {
        errors.push(EditAccountInfoFormFields_1.EditAccountInfoFormFields.PHONE_NUMBER);
    }
    if (!form.email.trim()) {
        errors.push(EditAccountInfoFormFields_1.EditAccountInfoFormFields.EMAIL);
    }
    return errors;
};
var getErrorMessageFromField = function (errorField, tForm) {
    if (errorField === EditAccountInfoFormFields_1.EditAccountInfoFormFields.NAME)
        return tForm.nameRequired;
    if (errorField === EditAccountInfoFormFields_1.EditAccountInfoFormFields.PHONE_NUMBER)
        return tForm.phoneRequired;
    if (errorField === EditAccountInfoFormFields_1.EditAccountInfoFormFields.EMAIL)
        return tForm.emailRequired;
    return '';
};
var watchFormChanged = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take([
                        AccountInfoAction_1.default.ACCOUNT_INFO_ON_SALUTATION_CHANGED,
                        AccountInfoAction_1.default.ACCOUNT_INFO_ON_FIRSTNAME_CHANGED,
                        AccountInfoAction_1.default.ACCOUNT_INFO_ON_LASTNAME_CHANGED,
                        AccountInfoAction_1.default.ACCOUNT_INFO_ON_EMAIL_CHANGED,
                        AccountInfoAction_1.default.ACCOUNT_INFO_ON_PHONE_BODY_CHANGED,
                        AccountInfoAction_1.default.ACCOUNT_INFO_ON_PHONE_CODE_CHANGED,
                        AccountInfoAction_1.default.ACCOUNT_INFO_ON_LANGUAGE_CHANGED,
                        AccountInfoAction_1.default.ACCOUNT_INFO_ON_CURRENCY_CHANGED,
                    ])];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(AccountInfoAction_1.default.onFormChanged())];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchFormValidation = function () {
    var _loop_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _loop_1 = function () {
                    var form, errorFields, tForm, errors;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, effects_1.take(AccountInfoAction_1.default.ACCOUNT_INFO_ON_FORM_CHANGED)];
                            case 1:
                                _a.sent();
                                return [4 /*yield*/, effects_1.put(AccountInfoAction_1.default.setServerErrors([]))];
                            case 2:
                                _a.sent();
                                return [4 /*yield*/, effects_1.select(getAccountForm)];
                            case 3:
                                form = _a.sent();
                                return [4 /*yield*/, effects_1.call(getFormError, form)];
                            case 4:
                                errorFields = _a.sent();
                                return [4 /*yield*/, effects_1.select(getTForm)];
                            case 5:
                                tForm = _a.sent();
                                errors = errorFields.map(function (it) { return ({
                                    type: it,
                                    message: getErrorMessageFromField(it, tForm)
                                }); });
                                return [4 /*yield*/, effects_1.put(AccountInfoAction_1.default.setErrors(errors))];
                            case 6:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                };
                _a.label = 1;
            case 1:
                if (!true) return [3 /*break*/, 3];
                return [5 /*yield**/, _loop_1()];
            case 2:
                _a.sent();
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/];
        }
    });
};
var watchDeleteClick = function () {
    var langCode;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(AccountInfoAction_1.default.ACCOUNT_INFO_ON_DELETE_ACCOUNT_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 2:
                langCode = _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.setUrl, "/" + langCode + "/profile/unsubscribe")];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchInitDate = function () {
    var accountForm, parsedYear, allYears;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(AccountInfoAction_1.default.ACCOUNT_INFO_ON_EDIT_CLICK)
                    // Check birthday year
                ];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getAccountForm)];
            case 2:
                accountForm = _a.sent();
                parsedYear = new Date(accountForm.birthday.replace(/-/g, '/')).getFullYear();
                return [4 /*yield*/, effects_1.select(getAllYears)];
            case 3:
                allYears = _a.sent();
                if (!(allYears.indexOf(parsedYear) === -1)) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.put(AccountInfoAction_1.default.onBirthdayYearChanged(allYears[0]))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var rootAccountInfoSagas = {
    rootMemberPageSagas: RootMemberPageSaga_1.rootMemberPageSagas,
    watchOnEditClick: watchOnEditClick,
    watchOnCancelClick: watchOnCancelClick,
    watchOnDeleteAccountClick: watchOnDeleteAccountClick,
    watchOnUpdateClick: watchOnUpdateClick,
    watchFormChanged: watchFormChanged,
    watchFormValidation: watchFormValidation,
    watchDeleteClick: watchDeleteClick,
    watchInitDate: watchInitDate,
};
exports.rootAccountInfoSagas = rootAccountInfoSagas;
